import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InternationalActivitiesComponent } from './international-activities.component';
import { InternationalActivitiesRoutingModule } from "./InternationalActivities-routing";
import { InternationalActivitiesFilterClass } from './InternationalActivities.pipe';

import { TranslateModule } from "@ngx-translate/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
      CommonModule,
      InternationalActivitiesRoutingModule,
      NgbModule,
    TranslateModule, FormsModule

      
    ],
  declarations: [InternationalActivitiesComponent, InternationalActivitiesFilterClass]
  })
  export class InternationalActivitiesModule { }
